export const COLORS = {
  white: "#ffffff",
  transparent: "#00000000",
  text: "#4e2e23",
  paper: "#e0d5c8dd",
  footerPaper: "#e0d5c8",
  action: "#f3a420",
  success: "#ff1493",
};
